export default __webpack_public_path__ + "static/media/carousel-1.9918fb4e.jpg";